import PedidoItemDetCodBarrasService from "@/services/PedidoItemDetCodBarrasService";

export const pedidoItemDetCodBarras = {
  namespaced: true,
  state: {
    pedidoItemDetCodBarras: {},
  },
  actions: {
    getPedidoItemDetCodBarras({ commit }, payload) {
      return PedidoItemDetCodBarrasService.GetPedidoItemDetCodBarras(
        payload
      ).then(
        (pedidoItemDetCodBarras) => {
          return Promise.resolve(pedidoItemDetCodBarras);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoItemDetCodBarras({ commit }, payload) {
      return PedidoItemDetCodBarrasService.PostPedidoItemDetCodBarras(
        payload
      ).then(
        (pedidoItemDetCodBarras) => {
          return Promise.resolve(pedidoItemDetCodBarras);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoItemDetCodBarras({ commit }, payload) {
      return PedidoItemDetCodBarrasService.PutPedidoItemDetCodBarras(
        payload
      ).then(
        (pedidoItemDetCodBarras) => {
          return Promise.resolve(pedidoItemDetCodBarras);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoItemDetCodBarras({ commit }, payload) {
      return PedidoItemDetCodBarrasService.DeletePedidoItemDetCodBarras(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoItemDetCodBarrasOData({ commit }, payload) {
      return PedidoItemDetCodBarrasService.GetPedidoItemDetCodBarrasOData(
        payload
      ).then(
        (pedidoItemDetCodBarras) => {
          return Promise.resolve(pedidoItemDetCodBarras);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoItemDetCodBarras;
